// Generated by LiveScript 1.6.0
var ref$, id, log, PUB_SPY, channels, check, pub, sub, subMany, enableSpying, out$ = typeof exports != 'undefined' && exports || this;
ref$ = require('utils'), id = ref$.id, log = ref$.log;
PUB_SPY = false;
channels = {};
check = function(ch){
  if (channels[ch] == null) {
    return channels[ch] = [];
  }
};
out$.pub = pub = function(ch){
  var msg, res$, i$, to$, ref$, len$, fn, results$ = [];
  res$ = [];
  for (i$ = 1, to$ = arguments.length; i$ < to$; ++i$) {
    res$.push(arguments[i$]);
  }
  msg = res$;
  check(ch);
  if (PUB_SPY) {
    log.apply(null, [" >> " + ch + " ->"].concat(msg));
  }
  for (i$ = 0, len$ = (ref$ = channels[ch]).length; i$ < len$; ++i$) {
    fn = ref$[i$];
    results$.push(fn != null ? fn.apply(this, msg) : void 8);
  }
  return results$;
};
out$.sub = sub = function(ch, fn){
  check(ch);
  return channels[ch].push(fn);
};
out$.subMany = subMany = function(obj){
  var ch, fn, results$ = [];
  for (ch in obj) {
    fn = obj[ch];
    results$.push(sub(ch, fn));
  }
  return results$;
};
out$.enableSpying = enableSpying = function(toggle){
  toggle == null && (toggle = true);
  return PUB_SPY = toggle;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInB1YnN1Yi5scyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVVBLElBQUEsR0FBYyxPQUFkLENBQXNCLE9BQUEsQ0FBdEIsRUFBRSxFQUFVLENBQUEsQ0FBQSxDQUFaLElBQUEsQ0FBQSxFQUFBLEVBQU0sR0FBTSxDQUFBLENBQUEsQ0FBWixJQUFBLENBQUE7QUFLQSxPQUFRLENBQUEsQ0FBQSxDQUFFO0FBRVYsUUFBUyxDQUFBLENBQUEsQ0FBRTtBQUtYLEtBQU0sQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLEVBQUE7RUFDTixJQUFJLFFBQVEsQ0FBQyxFQUFELENBQVQsUUFBSDtXQUNFLFFBQVEsQ0FBQyxFQUFELENBQUssQ0FBQSxDQUFBLENBQUU7OztXQUtaLEdBQUksQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLEVBQUE7Ozs7OztFQUFRO0VBQ25CLE1BQU0sRUFBQTtFQUNOLElBQUcsT0FBSDtJQUFnQixHQUFHLENBQUMsTUFBTSxNQUFNLENBQUMsTUFBQSxDQUFBLENBQUEsQ0FBSyxFQUFBLENBQUEsQ0FBQSxDQUFBLEtBQU4sQ0FBYyxDQUFDLE9BQU8sR0FBQSxDQUE1Qjs7RUFDMUIsaUVBQUE7SUFBSTtrQkFDRixXQUFBLEVBQUEsRUFBRyxDQUFBLE1BQU0sTUFBTSxHQUFOOzs7O1dBRU4sR0FBSSxDQUFBLENBQUEsQ0FBRSxRQUFBLENBQUEsRUFBQSxFQUFBLEVBQUE7RUFDWCxNQUFNLEVBQUE7U0FDTixRQUFRLENBQUMsRUFBRCxDQUFJLENBQUMsS0FBSyxFQUFBOztlQUViLE9BQVMsQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLEdBQUE7O0VBQ2hCLFdBQWMsR0FBZDtJQUFRO2tCQUNOLElBQUksSUFBSSxFQUFKOzs7O29CQUVELFlBQWEsQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLE1BQUE7RUFBQyxtQkFBQSxTQUFTO1NBQzlCLE9BQVEsQ0FBQSxDQUFBLENBQUciLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==

